import config from '../config';
import http from '@/utils/http';
import { Departure } from '@/types/api/transport';
import { logger } from '@/utils/screenEventsLogger';

export async function getDepartures(
  stopId: unknown,
  transportTypes: unknown,
): Promise<Departure[] | null> {
  try {
    const apiUrl = `${config.apiUrl}userapi/traffiklab/timetables/departures`;
    const response = await http.get(apiUrl, {
      'axios-retry': {
        retries: 0,
      },
      params: {
        stopId: stopId,
        transportTypes: transportTypes,
      },
    });

    return response.data;
  } catch (error: any) {
    logger.addLog(`Trafiklab API request failed: ${error?.message}.`);

    return null;
  }
}
